module.exports = "<p>\n  manageobjects works!\n</p>\n"